import { jsx as _jsx } from "react/jsx-runtime";
import { darkTheme, theme } from '@storybook/react-native-theming';
import { useRef } from 'react';
import { useColorScheme } from 'react-native';
import Storybook from './Storybook';
import setupErrorSilencing from './setupErrorSilencing';
import useTestAllStories from './useTestAllStories';
import SherloModule from '../../../SherloModule';
import deepmerge from 'deepmerge';
import { MetadataProvider } from './MetadataProvider';
setupErrorSilencing();
const lastState = SherloModule.getLastState();
function TestingMode({ view, params, }) {
    var _a, _b, _c;
    const defaultTheme = useColorScheme() === 'dark' ? darkTheme : theme;
    const metadataProviderRef = useRef(null);
    useTestAllStories({
        view,
        metadataProviderRef,
    });
    const nextSnapshot = lastState === null || lastState === void 0 ? void 0 : lastState.nextSnapshot;
    const uiSettings = nextSnapshot
        ? {
            theme: deepmerge(defaultTheme, (_b = (_a = nextSnapshot.parameters) === null || _a === void 0 ? void 0 : _a.theme) !== null && _b !== void 0 ? _b : {}),
            shouldAddSafeArea: !((_c = nextSnapshot.parameters) === null || _c === void 0 ? void 0 : _c.noSafeArea),
        }
        : {
            theme: defaultTheme,
            shouldAddSafeArea: true,
        };
    return (_jsx(MetadataProvider, { ref: metadataProviderRef, children: _jsx(Storybook, { params: params, uiSettings: uiSettings, view: view }) }));
}
export default TestingMode;
//# sourceMappingURL=TestingMode.js.map